module.exports = __webpack_public_path__ + "img/after-2.c48be1d9.png";